/**
 * Lightweight analytics wrapper.
 *
 *  - Uses PostHog if REACT_APP_POSTHOG_KEY is set at build time (product events)
 *  - Uses Google Analytics 4 if REACT_APP_GA_ID is set (marketing / acquisition)
 *  - No-op silently if neither is configured. Zero runtime error.
 *
 * Track events with track("name", { ...props }).
 * Track page views with page(path).
 */

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";
const GA_ID = process.env.REACT_APP_GA_ID;

let ph = null;
let gaReady = false;

function loadPostHog() {
  if (!POSTHOG_KEY || typeof window === "undefined") return;
  // Standard PostHog snippet (async)
  const script = document.createElement("script");
  script.async = true;
  script.src = `${POSTHOG_HOST}/static/array.js`;
  script.onload = () => {
    if (window.posthog) {
      window.posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        capture_pageview: false,
        person_profiles: "identified_only",
      });
      ph = window.posthog;
    }
  };
  document.head.appendChild(script);
}

function loadGA() {
  if (!GA_ID || typeof window === "undefined") return;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { send_page_view: false });
  gaReady = true;
}

export function initAnalytics() {
  try {
    loadPostHog();
    loadGA();
  } catch (_) { /* noop */ }
}

export function identify(userId, traits = {}) {
  if (ph) ph.identify(userId, traits);
  if (gaReady && window.gtag) window.gtag("set", "user_properties", traits);
}

export function track(event, props = {}) {
  if (ph) ph.capture(event, props);
  if (gaReady && window.gtag) window.gtag("event", event, props);
}

export function page(path) {
  if (ph) ph.capture("$pageview", { $current_url: path });
  if (gaReady && window.gtag) window.gtag("event", "page_view", { page_path: path });
}

export function reset() {
  if (ph) ph.reset();
}
